// src/components/admin/users/UserTable.js
import React from "react";
import { useAuth } from "../../../hooks/pages/useAuth";

const UserTable = ({ users, onEdit, onDelete, onViewCars }) => {
    // Lấy thông tin user hiện tại từ hook useAuth
    const { user: currentUser } = useAuth();
    return (
        <div className="mt-4">
            {/* ====== TABLE DÀNH CHO MÀN HÌNH LỚN (Desktop) ====== */}
            <div className="hidden lg:block overflow-x-auto">
                <table className="w-full table-auto border text-sm border-gray-300 dark:border-gray-700">
                    <thead>
                        <tr className="bg-gray-100 dark:bg-gray-800 dark:text-gray-200">
                            <th className="p-2 border border-gray-300 dark:border-gray-700">ID</th>
                            <th className="p-2 border border-gray-300 dark:border-gray-700">Tên</th>
                            <th className="p-2 border border-gray-300 dark:border-gray-700">Email</th>
                            <th className="p-2 border border-gray-300 dark:border-gray-700">SĐT</th>
                            <th className="p-2 border border-gray-300 dark:border-gray-700">Vai trò</th>
                            <th className="p-2 border border-gray-300 dark:border-gray-700">Hành động</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr
                                key={user.id}
                                className="dark:text-gray-200 dark:hover:bg-gray-700 hover:bg-gray-50"
                            >
                                <td className="p-2 border border-gray-300 dark:border-gray-700">{user.id}</td>
                                <td className="p-2 border border-gray-300 dark:border-gray-700">{user.name}</td>
                                <td className="p-2 border border-gray-300 dark:border-gray-700">{user.email}</td>
                                <td className="p-2 border border-gray-300 dark:border-gray-700">{user.phone}</td>
                                <td className="p-2 border border-gray-300 dark:border-gray-700">{user.role}</td>
                                <td className="p-2 border border-gray-300 dark:border-gray-700 space-x-2">
                                    {currentUser?.role === "admin" && (
                                        <>
                                            <button
                                                onClick={() => onEdit(user)}
                                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-sm"
                                            >
                                                Sửa
                                            </button>
                                            <button
                                                onClick={() => onDelete(user.id)}
                                                className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-sm"
                                            >
                                                Xoá
                                            </button>
                                        </>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* ====== VIEW DẠNG THẺ DÀNH CHO MOBILE ====== */}
            <div className="lg:hidden space-y-4">
                {users.map((user) => (
                    <div
                        key={user.id}
                        className="border rounded p-4 bg-white dark:bg-gray-800 border-gray-300 dark:border-gray-700 shadow-sm text-sm dark:text-gray-200"
                    >
                        <div><strong>ID:</strong> {user.id}</div>
                        <div><strong>Tên:</strong> {user.name}</div>
                        <div><strong>Email:</strong> {user.email}</div>
                        <div><strong>SĐT:</strong> {user.phone}</div>
                        <div><strong>Vai trò:</strong> {user.role}</div>
                        <div className="mt-2 space-x-2">
                            {currentUser?.role === "admin" && (
                                <>
                                    <button
                                        onClick={() => onEdit(user)}
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
                                    >
                                        Sửa
                                    </button>
                                    <button
                                        onClick={() => onDelete(user.id)}
                                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
                                    >
                                        Xoá
                                    </button>
                                </>
                            )}
                            <button
                                onClick={() => onViewCars(user.id)}
                                className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm"
                            >
                                Xem xe
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UserTable;
